import { connect, mapProps } from '@formily/react';
import { CnCheckbox as UiCnCheckbox, CnCheckboxGroup as UiCnCheckboxGroup, } from "../../components/cn-checkbox";
import { mapSize } from "../__builtins__";
export var CnCheckbox = connect(UiCnCheckbox, mapProps(mapSize));
CnCheckbox.displayName = 'CnCheckbox';
export var CnCheckboxGroup = connect(UiCnCheckboxGroup, mapProps({
    dataSource: true,
}, mapSize));
CnCheckboxGroup.displayName = 'CnCheckboxGroup';
